import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FiChevronDown,
  FiShoppingCart,
  FiSearch,
  FiChevronRight,
} from "react-icons/fi";
import HeaderBar from "../common/HeaderBar";
import { ProductConsumer } from "../../productcontext";
import $ from "jquery";
import MenuCart from "./menucart/MenuCart";
import { FaTimes } from "react-icons/all";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import sectiondata from "../../store/store";
import SearchModal from "./SearchModal";

export default function Navbar() {
  const [searchOpen, setsearchOpen] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [navOpen, setnavOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        setIsSearchModalOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  /*====  side-widget-menu  =====*/
  $(document).on(
    "click",
    ".side-menu-wrap .side-menu-ul .sidenav__item",
    function () {
      $(".side-menu-wrap .side-menu-ul .sidenav__item").removeClass("active");
      $(this).toggleClass("active");
    }
  );
  $(document).on(
    "click",
    ".side-menu-wrap .side-menu-ul .sidenav__item.active",
    function () {
      $(".side-menu-wrap .side-menu-ul .sidenav__item.active").removeClass(
        "active"
      );
    }
  );

  $(window).on("scroll", function () {
    // Header Menu Fixed
    if ($(window).scrollTop() > 30) {
      $("body").addClass("header-menu-fixed");
      $(".scroll-d-block").addClass("d-block");
    } else {
      $("body").removeClass("header-menu-fixed");
      $(".scroll-d-block").removeClass("d-block");
    }
  });

  const getFocusableDropdownItems = (dropdown) => {
    if (!dropdown) return [];
    const allLinks = dropdown.querySelectorAll("li a");
    const focusableItems = [];
    allLinks.forEach((link) => {
      const rect = link.getBoundingClientRect();
      if (rect.height > 0 && rect.width > 0) {
        focusableItems.push(link);
      }
    });
    return focusableItems;
  };

  const handleDropdownKeyDown = (event, menuTitle, itemIndex) => {
    const button = event.currentTarget;
    const li = button.closest("li");
    const dropdown = li?.querySelector(".dropdown-menu-item");

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const newState = openDropdown === menuTitle ? null : menuTitle;
      setOpenDropdown(newState);
      if (newState === menuTitle) {
        requestAnimationFrame(() => {
          const items = getFocusableDropdownItems(dropdown);
          if (items.length > 0) {
            items[0].focus();
          }
        });
      }
    } else if (event.key === "Escape") {
      setOpenDropdown(null);
      button.focus();
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      if (openDropdown !== menuTitle) {
        setOpenDropdown(menuTitle);
        requestAnimationFrame(() => {
          const items = getFocusableDropdownItems(dropdown);
          if (items.length > 0) {
            items[0].focus();
          }
        });
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      if (openDropdown !== menuTitle) {
        setOpenDropdown(menuTitle);
        requestAnimationFrame(() => {
          const items = getFocusableDropdownItems(dropdown);
          if (items.length > 0) {
            items[items.length - 1].focus();
          }
        });
      }
    }
  };

  const handleDropdownItemKeyDown = (event, menuTitle) => {
    if (event.key === "Escape") {
      event.preventDefault();
      setOpenDropdown(null);
      const dropdown = event.currentTarget.closest(".dropdown-menu-item");
      const menuButton = dropdown?.previousElementSibling;
      if (menuButton) {
        menuButton.focus();
      }
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      const dropdown = event.currentTarget.closest(".dropdown-menu-item");
      const items = getFocusableDropdownItems(dropdown);
      if (items.length > 0) {
        const currentLink = event.currentTarget;
        let currentIndex = items.indexOf(currentLink);
        if (currentIndex === -1) {
          currentIndex = 0;
        } else {
          currentIndex = (currentIndex + 1) % items.length;
        }
        items[currentIndex].focus();
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      const dropdown = event.currentTarget.closest(".dropdown-menu-item");
      const items = getFocusableDropdownItems(dropdown);
      if (items.length > 0) {
        const currentLink = event.currentTarget;
        let currentIndex = items.indexOf(currentLink);
        if (currentIndex === -1) {
          currentIndex = items.length - 1;
        } else {
          currentIndex = (currentIndex - 1 + items.length) % items.length;
        }
        items[currentIndex].focus();
      }
    }
  };

  const closeDropdown = () => {
    setOpenDropdown(null);
  };

  return (
    <>
      <a
        href="#main-content"
        className="skip-to-main-content"
        onClick={(e) => {
          e.preventDefault();
          const mainContent = document.getElementById("main-content");
          if (mainContent) {
            window.scrollTo(0, 0);
            mainContent.setAttribute("tabindex", "-1");
            mainContent.focus();
          }
        }}
      >
        Skip to Main Content
      </a>
      <HeaderBar />

      <div className="header-menu-wrapper scroll-d-block"style={{ padding:"10px"}}>
        <div className="header-menu-container "style={{ marginLeft:"0px", maxWidth: "95%"}}>
          <div className="header-menu-flex"style={{margin:"0px"}}>
            <div className="header-menu-left">
              <Link to="/">
                <img
                  src={sectiondata.HeaderData.HeaderMenuBar.logourl}
                  alt="agreya capital logo"
                  height="40px"
                  style={{ height:"50px"}}
                />
              </Link>
            </div>
            <div className="header-menu-right"style={{ marginRight:"0px"}}>
              <nav>
                <ul>
                  {sectiondata.HeaderData.HeaderMenuBar.menus.map(
                    (item, index) => {
                      return (
                        <li
                          key={index}
                        >
                          {item.link ? (
                            <a
                              style={{
                                width: "auto",
                                wordWrap: "normal",
                                lineHeight: "1",
                                margin: "20px 0",
                              }}
                              href={item.link}
                              target="_blank"
                              aria-label={`${item.title}, opens in new tab`}
                            >
                              {item.title}
                            </a>
                          ) : (
                            ""
                          )}
                          {item.title === "Investment Approaches" ? (
                            item.path ? (
                              <Link to={item.path}>
                                <span
                                  style={{
                                    width: "auto",
                                    wordWrap: "normal",
                                    lineHeight: "1",
                                    margin: "20px 0",
                                  }}
                                >
                                  {item.title}
                                </span>
                              </Link>
                            ) : (
                              <a
                                href="#"
                                style={{
                                  width: "auto",
                                  wordWrap: "normal",
                                  lineHeight: "1",
                                  margin: "20px 0",
                                }}
                                onClick={(e) => e.preventDefault()}
                              >
                                {item.title}
                              </a>
                            )
                          ) : item.path && !item.dropdown ? (
                            <Link to={item.path}>
                              <span
                                style={{
                                  width: "auto",
                                  wordWrap: "normal",
                                  lineHeight: "1",
                                  margin: "20px 0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                title={item.title}
                                aria-label={item.title}
                              >
                                {item.icon ? (
                                  <FontAwesomeIcon
                                    icon={faShieldAlt}
                                    style={{
                                      fontSize: "20px",
                                      color: "#c39239",
                                    }}
                                  />
                                ) : (
                                  item.title
                                )}
                              </span>
                            </Link>
                          ) : (
                            ""
                          )}
                          {item.dropdown && item.title !== "Investment Approaches" ? (
                            <>
                              <a
                                tabIndex="0"
                                role="button"
                                aria-haspopup="true"
                                aria-expanded={openDropdown === item.title ? "true" : "false"}
                                aria-controls={`dropdown-${item.title.replace(/\s+/g, "-").toLowerCase()}`}
                                aria-label={`${item.title}, menu button. Press Enter or Space to open the menu.`}
                                onKeyDown={(e) => handleDropdownKeyDown(e, item.title, index)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setOpenDropdown(openDropdown === item.title ? null : item.title);
                                }}
                                style={{
                                  width: "auto",
                                  wordWrap: "normal",
                                  lineHeight: "1",
                                  margin: "20px 0",
                                  cursor: "pointer",
                                }}
                              >
                                {item.title}
                              </a>
                              <ul
                                id={`dropdown-${item.title.replace(/\s+/g, "-").toLowerCase()}`}
                                className={`dropdown-menu-item ${openDropdown === item.title ? "keyboard-open" : ""}`}
                                role="menu"
                                aria-hidden={openDropdown !== item.title ? "true" : "false"}
                              >
                              {item.dropdown.map((dp_item, i) => {
                                return (
                                  <li key={i}>
                                    {dp_item.link ? (
                                      <a
                                        tabIndex={openDropdown === item.title ? 0 : -1}
                                        style={{
                                          width: "auto",
                                          wordWrap: "normal",
                                          lineHeight: "1",
                                          margin: "20px 0",
                                        }}
                                        href={dp_item.link}
                                        target="_blank"
                                        onKeyDown={(e) => handleDropdownItemKeyDown(e, item.title)}
                                      >
                                        {dp_item.title}
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                    {dp_item.path ? (
                                      <span className="desktop-only">
                                        <a tabIndex={openDropdown === item.title ? 0 : -1} href={dp_item.path} target="_blank" onKeyDown={(e) => handleDropdownItemKeyDown(e, item.title)}>{dp_item.title}</a>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    {dp_item.dep_dropdown ? (
                                      <ul className="dropdown-menu-item">
                                        {dp_item.dep_dropdown.map((dp_item_inr, i2) => {
                                          return (
                                            <li key={i2}>
                                              <Link to={dp_item_inr.path}>
                                                {dp_item_inr.title}
                                              </Link>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    ) : (
                                      ""
                                    )}
                                  </li>
                                );
                              })}
                              </ul>
                            </>
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    }
                  )}
                </ul>
              </nav>
              <div className="header-menu-right-flex">
                {/* <div className="header-menu-cart">
                  <ul>
                    <li>
                      <div className="cart__icon">
                        <Link to="#">
                          <FiShoppingCart />
                        </Link>
                        <span className="cart__item-count">
                          <ProductConsumer>
                            {(value) => {
                              const { cart } = value;
                              if (cart.length > 0) {
                                return <span>{cart.length}</span>;
                              } else {
                                return "0";
                              }
                            }}
                          </ProductConsumer>
                        </span>
                      </div>

                      <MenuCart />
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="search-button"
                        onClick={() => setsearchOpen(!searchOpen)}
                      >
                        {searchOpen ? (
                          <FaTimes className="search-icon" />
                        ) : (
                          <FiSearch className="search-icon" />
                        )}
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div
                  className={
                    searchOpen
                      ? "header-menu-searchform active"
                      : "header-menu-searchform"
                  }
                >
                  <form action="#">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search by keywords..."
                    />
                    <div className="form-icon">
                      <FiSearch className="search-icon" />
                    </div>
                  </form>
                </div>
                <button
                  className="search-modal-trigger"
                  onClick={() => setIsSearchModalOpen(true)}
                  aria-label="Open search (Ctrl+K)"
                  title="Search pages and features (Ctrl+K)"
                >
                  <FiSearch className="search-icon" />
                </button>
                <div
                  className="side-menu-open"
                  onClick={() => setnavOpen(!navOpen)}
                >
                  <span className="menu__bar"></span>
                  <span className="menu__bar"></span>
                  <span className="menu__bar"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<div
  className={navOpen ? "side-nav-container active" : "side-nav-container"}
  role="navigation"
  aria-label="Mobile menu"
  aria-hidden={!navOpen}
  onKeyDown={(e) => {
    if (e.key === "Escape") {
      setnavOpen(false);
    }
  }}
>
  <div className="humburger-menu">
    <button
      className="humburger-menu-lines side-menu-close"
      onClick={() => setnavOpen(!navOpen)}
      tabIndex={navOpen ? 0 : -1}
      aria-label={navOpen ? "Close menu" : "Open menu"}
      aria-expanded={navOpen}
      aria-controls="side-menu-wrap"
    ></button>
  </div>
  <div className="side-menu-wrap" id="side-menu-wrap">
    <ul className="side-menu-ul">
      {sectiondata.HeaderData.HeaderMenuBar.menus.map((item, index) => (
        <li
          className="sidenav__item"
          key={index}
          style={{ pointerEvents: navOpen ? "auto" : "none" }}
        >
          {item.path || item.link ? (
            <>
              {item.link ? (
                <a
                  tabIndex={navOpen ? 0 : -1}
                  href={item.link}
                  onClick={() => setnavOpen(false)}
                  style={{ pointerEvents: navOpen ? "auto" : "none" }}
                >
                  {item.title}
                </a>
              ) : null}
              {item.path ? (
                <Link
                  tabIndex={navOpen ? 0 : -1}
                  to={item.path}
                  onClick={() => setnavOpen(false)}
                  style={{ pointerEvents: navOpen ? "auto" : "none" }}
                >
                  {item.title}
                </Link>
              ) : null}
            </>
          ) : null}
          {item.dropdown ? <span className="menu-plus-icon"></span> : null}
          {item.dropdown ? (
            <ul className="side-sub-menu" aria-hidden={!navOpen}>
              {item.dropdown.map((dp_item, i) => (
                <li key={i}>
                  {dp_item.link ? (
                    <a
                      tabIndex={navOpen ? 0 : -1}
                      href={dp_item.link}
                      onClick={() => setnavOpen(false)}
                    >
                      {dp_item.title}
                    </a>
                  ) : null}
                  {dp_item.path ? (
                    <Link
                      tabIndex={navOpen ? 0 : -1}
                      to={dp_item.path}
                      onClick={() => setnavOpen(false)}
                    >
                      {dp_item.title}
                    </Link>
                  ) : null}
                </li>
              ))}
            </ul>
          ) : null}
        </li>
      ))}
    </ul>
  </div>
</div>
      <SearchModal
        isOpen={isSearchModalOpen}
        onClose={() => setIsSearchModalOpen(false)}
      />
</>
  );
}